import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div>
          <strong>Ibraflex</strong> &copy; 2022
        </div>
      </div>
    </>
  );
};

export default Footer;
